/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".link-group[_ngcontent-%COMP%]{margin-top:25px}.link-group[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{padding-bottom:0}.link-group[_ngcontent-%COMP%]   .fa-external-link[_ngcontent-%COMP%]{padding-left:5px}.legal[_ngcontent-%COMP%]{color:#0b4166}.legal-note[_ngcontent-%COMP%]{font-size:11px;margin-left:20px;color:#424242}"];
export { styles as styles };
